"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["value", "className", "bsStyle", "tagName", "border"];
var hasGrade = function hasGrade(value) {
  var _context;
  return value && (0, _indexOf["default"])(_context = ['A', 'B', 'C', 'D', 'F']).call(_context, value.toUpperCase()) >= 0;
};
var Grade = function Grade(_ref) {
  var value = _ref.value,
    className = _ref.className,
    bsStyle = _ref.bsStyle,
    tagName = _ref.tagName,
    border = _ref.border,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var grade;
  var gradeClass;
  if (hasGrade(value)) {
    grade = value.toUpperCase();
    gradeClass = "grade-".concat(value.toLowerCase());
  } else if (value.toLowerCase() === '.') {
    grade = /*#__PURE__*/_react["default"].createElement("i", {
      className: "icon icon-lock"
    });
    gradeClass = 'grade-na';
  } else {
    grade = 'N/A';
    gradeClass = 'grade-na';
  }
  var classes = {
    'grade-badge': true,
    'grade-inline': bsStyle === 'inline',
    'grade-featured': bsStyle === 'featured',
    'grade-sm': bsStyle === 'small',
    'grade-lg': bsStyle === 'large',
    'grade-bordered': border
  };
  var joinedClassName = (0, _classnames["default"])(className, gradeClass, (0, _classnames["default"])(classes));
  var GradeBadgeComponent = tagName;
  return /*#__PURE__*/_react["default"].createElement(GradeBadgeComponent, (0, _extends2["default"])({
    "aria-label": "Grade"
  }, rest, {
    className: joinedClassName
  }), grade);
};
Grade.propTypes = {
  value: _propTypes["default"].string,
  className: _propTypes["default"].string,
  tagName: _propTypes["default"].string,
  bsStyle: _propTypes["default"].oneOf(['standard', 'small', 'large', 'featured', 'inline']),
  border: _propTypes["default"].bool
};
Grade.defaultProps = {
  className: 'test',
  tagName: 'span',
  bsStyle: 'standard',
  border: false,
  value: 'N/A'
};
var _default = exports["default"] = Grade;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Grade.js
// module id = 6187
// module chunks = 25